module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M22 14v-4c0-5.524-4.476-10-10-10S2 4.476 2 10v4c-1.106 0-2 .894-2 2v14c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V16c0-1.106-.894-2-2-2zm-4 0H6v-4c0-3.308 2.692-6 6-6s6 2.692 6 6v4zm-6 14a2 2 0 0 1-2-2v-6a2 2 0 1 1 4 0v6a2 2 0 0 1-2 2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/lock-2.js
// module id = 1244
// module chunks = 14